/*
 * @Author: Cphayim
 * @Date: 2020-10-21 13:46:21
 * @Description: auth 路由
 */
import IndexPage from '@/render/views/index'
import LoginPage from '@/render/views/auth/login'
// import RegisterPage from '@/render/views/auth/register'
// import ForgetPage from '@/render/views/auth/forget'
// import CollectionPage from '@/render/views/auth/collection'

// const IndexPage = () => import('@/render/views/index')
// const LoginPage = () => import('@/render/views/auth/login')
// const RegisterPage = () => import('@/render/views/auth/register')
// const ForgetPage = () => import('@/render/views/auth/forget')
// const CollectionPage = () => import('@/render/views/auth/collection')

export default [
  {
    path: '/',
    name: 'Index',
    component: IndexPage,
    meta: {
      title: '首页',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: {
      title: '登录',
      keepAlive: false,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: resolve => require.ensure([], () => resolve(require('@/render/views/auth/register')), 'auth'),
    meta: {
      title: '注册',
      keepAlive: false,
    },
  },
  {
    path: '/forget',
    name: 'Forget',
    component: resolve => require.ensure([], () => resolve(require('@/render/views/auth/forget')), 'auth'),
    meta: {
      title: '忘记密码',
      keepAlive: false,
    },
  }, {
    path: '/collection',
    name: 'Collection',
    component: resolve => require.ensure([], () => resolve(require('@/render/views/auth/collection')), 'auth'),
    meta: {
      title: '信息补录页',
      keepAlive: false
    }
  },
]
